var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountBalanceWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9062 10.0781C12.2188 10.3594 12.5781 10.5 12.9844 10.5C13.3906 10.5 13.7344 10.3594 14.0156 10.0781C14.3281 9.79688 14.4844 9.4375 14.4844 9C14.4844 8.5625 14.3281 8.20312 14.0156 7.92188C13.7344 7.64062 13.3906 7.5 12.9844 7.5C12.5781 7.5 12.2188 7.64062 11.9062 7.92188C11.625 8.20312 11.4844 8.5625 11.4844 9C11.4844 9.4375 11.625 9.79688 11.9062 10.0781ZM9 12.9844V5.01562H18.9844V12.9844H9ZM18 15V15.9844C18 16.5156 17.7969 16.9844 17.3906 17.3906C16.9844 17.7969 16.5156 18 15.9844 18H2.01562C1.45312 18 0.96875 17.8125 0.5625 17.4375C0.1875 17.0312 0 16.5469 0 15.9844V2.01562C0 1.45312 0.1875 0.984375 0.5625 0.609375C0.96875 0.203125 1.45312 0 2.01562 0H15.9844C16.5156 0 16.9844 0.203125 17.3906 0.609375C17.7969 1.01563 18 1.48438 18 2.01562V3H9C8.4375 3 7.95312 3.20312 7.54688 3.60938C7.17188 3.98438 6.98438 4.45312 6.98438 5.01562V12.9844C6.98438 13.5469 7.17188 14.0312 7.54688 14.4375C7.95312 14.8125 8.4375 15 9 15H18Z",
    fill: "#525252"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountBalanceWallet);
export default __webpack_public_path__ + "static/media/account_balance_wallet.d0069a3c61d019263efd38b0de6c66ae.svg";
export { ForwardRef as ReactComponent };